import React, { PureComponent } from 'react'
import { func, string, bool } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import Button from '@active/react-ui/Button'
import I18nMessage from '../../../I18nMessage'
import './FacebookButton.scss'

class FacebookButton extends PureComponent {
  static propTypes = {
    // For keycloak v5
    onIdpSignin: func,
    name: string,
    // For passport v4
    onFacebookSignin: func,
    facebookText: string,
    loginUrl: string,
    keycloakAPIServerHost: string,
    isPageModel: bool,
  }

  static defaultProps = {
    onIdpSignin: null,
    name: null,
    onFacebookSignin: null,
    loginUrl: '',
    facebookText: 'passport.common.text.signInWith',
    keycloakAPIServerHost: '',
    isPageModel: false,
  }

  handleFacebookSignin = clickEvent => {
    const {
      loginUrl, keycloakAPIServerHost, onFacebookSignin, onIdpSignin, name, isPageModel,
    } = this.props
    // For keycloak v5 page
    if (isPageModel && loginUrl) {
      const keycloakOrigin = new URL(keycloakAPIServerHost).origin
      window.location.href = `${keycloakOrigin}${loginUrl}`
      return false
    }
    // For keycloak v5 widget
    if (onIdpSignin) {
      return onIdpSignin({ clickEvent, name })
    }
    // For passport v4
    if (onFacebookSignin) {
      onFacebookSignin(loginUrl)
    }
    return false
  }

  render() {
    return (
      <div className="passport-ui-app__facebook-button">
        <Responsive eqAbove="md">
          <Button type="secondary" className="passport__facebook-btn" 
            onClick={this.handleFacebookSignin}
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                  this.handleFacebookSignin()
                }
              }}
            >
            <i className="facebook-btn-icon facebook-img-r ic-facebook-r" />
            <span className="facebook-btn-text">
              <I18nMessage id="passport.common.text.continueWithFacebook" />
            </span>
          </Button>
        </Responsive>
        <Responsive eqAbove="md" not>
          <Button type="secondary" className="passport__facebook-btn" onClick={this.handleFacebookSignin}>
            <i className="facebook-btn-icon facebook-img-r ic-facebook-r" />
            <span className="facebook-btn-text">
              <I18nMessage id="passport.common.text.continueWithFacebook" />
            </span>
          </Button>
        </Responsive>
      </div>
    )
  }
}

export default withI18n(FacebookButton)
